import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import { soccerTrainingTrackerPath } from '../utils/paths';
import './TrainingTodayCard.css';

const PILLAR_LABELS = {
  STRENGTH: 'Strength',
  STAMINA: 'Stamina',
  SKILL: 'Skill',
};

const TrainingTodayCard = ({ userId }) => {
  const [today, setToday] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadToday = useCallback(async () => {
    if (!userId) {
      setToday(null);
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      const data = await api.getTrainingToday(userId);
      setToday(data);
    } catch {
      setToday(null);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    loadToday();
  }, [loadToday]);

  if (!userId || loading) {
    return null;
  }

  const planned = today?.plannedActivities || [];
  const completed = today?.log?.completedCount ?? 0;
  const total = planned.length || today?.log?.totalCount || 0;

  return (
    <section className="training-today-card" aria-label="Today's training">
      <div className="training-today-card__header">
        <div>
          <h2>Today&apos;s training</h2>
          <p>
            {today?.plan
              ? today.plan.title
              : 'Start a weekly strength, stamina, and skill plan.'}
          </p>
        </div>
        <Link to={soccerTrainingTrackerPath()} className="training-today-card__link">
          Open Training →
        </Link>
      </div>

      {!today?.plan && (
        <p className="training-today-card__empty">
          No active plan yet. Choose a beginner, intermediate, or match-week template.
        </p>
      )}

      {today?.plan && planned.length === 0 && (
        <p className="training-today-card__empty">
          No session scheduled for today on your current plan.
        </p>
      )}

      {planned.length > 0 && (
        <>
          <ul className="training-today-card__list">
            {planned.slice(0, 3).map((activity) => (
              <li key={activity.id}>
                <span className={`training-today-card__pillar training-today-card__pillar--${activity.pillar.toLowerCase()}`}>
                  {PILLAR_LABELS[activity.pillar] || activity.pillar}
                </span>
                <span>{activity.title}</span>
              </li>
            ))}
          </ul>
          <p className="training-today-card__meta">
            {completed}/{total || planned.length} logged · streak {today?.currentStreak ?? 0}
          </p>
        </>
      )}

      <Link to={soccerTrainingTrackerPath()} className="btn btn-primary training-today-card__cta">
        {today?.plan ? 'Log today' : 'Choose a plan'}
      </Link>
    </section>
  );
};

export default TrainingTodayCard;
